import {createContext, useContext} from "react";
import {useMails} from "../hooks/api/mailbox";

const MailboxContext = createContext();

const MailboxProvider = ({children}) => {
    const [{mails, mailConversation, metaData, apiErrors, loading}, {fetchAll, fetchMailConversation, resetApiErrors, load}] = useMails()

    return <MailboxContext.Provider value={{ mails, mailConversation, metaData, apiErrors, loading, fetchAll, fetchMailConversation, resetApiErrors, load }}>
        {children}
    </MailboxContext.Provider>;
}

export default MailboxProvider

export const useMail = () => {
    return useContext(MailboxContext);
};